import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function BoxedDoctorNavbar({ setSearchModal }) {
  const [isSticky, setIsSticky] = useState(false);
  const patientLogin = useSelector((state) => state.patient.patientLogin);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="py-3">
      <div className="">
        <div className="basic-container clearfix typo-white">
        <ul className="nav topbar-items pull-left">
            <li className="nav-item">
              <ul className="nav header-info">
                <div className="header-address boxed-header-social-wrapper">
                  <span className="ti-headphone-alt"></span>
                  <a
                    href={`tel:${sitedata?.site_contact}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    {sitedata?.site_contact}
                  </a>
                  <span className="ti-email ms-3"></span>
                  <a className="" href={`mailto:${sitedata?.business_email || sitedata?.site_email}`}>
                    {sitedata?.business_email || sitedata?.site_email}
                  </a>
                </div>
              </ul>
            </li>
          </ul>
          <ul className="nav topbar-items pull-right">
            <li className="nav-item">
              <div className="social-icons boxesd-header-social-icons">
                {sitedata?.site_extra?.facebook_link && (
                  <a
                    href={sitedata?.site_extra?.facebook_link}
                    className="social-fb"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="ti-facebook"></span>
                  </a>
                )}
                {sitedata?.site_extra?.twitter_link && (
                  <a
                    href={sitedata?.site_extra?.twitter_link}
                    className="social-twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fab fa-x-twitter "></span>
                  </a>
                )}
                {sitedata?.site_extra?.instagram_link && (
                  <a
                    href={sitedata?.site_extra?.instagram_link}
                    className="social-instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="ti-instagram"></span>
                  </a>
                )}
                {sitedata?.site_extra?.linkedin_link && (
                  <a
                    href={sitedata?.site_extra?.linkedin_link}
                    className="social-instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="ti-linkedin"></span>
                  </a>
                )}
                {sitedata?.site_extra?.tiktok_link && (
                  <a
                    href={sitedata?.site_extra?.tiktok_link}
                    className="social-tiktok"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fab fa-tiktok"></span>
                  </a>
                )}
                {sitedata?.site_extra?.youtube_link && (
                  <a
                    href={sitedata?.site_extra?.youtube_link}
                    className="social-youtube"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fab fa-youtube"></span>
                  </a>
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="sticky-outer full-dark">
        <div className={`sticky-head ${isSticky ? "header-sticky" : ""}`}>
          <nav className="navbar boxed-header-navbar-bg">
            <div className="basic-container clearfix boxed-header-navbar-wrapper">
              <div className="navbar-inner">
                <ul className="nav navbar-items pull-left">
                  <li className="list-item">
                    <Link
                      to={"/"}
                      className="logo-general d-flex align-items-center gap-1"
                    >
                      <img
                        src={
                          sitedata?.site_logo
                            ? `${sitedata?.site_logo}`
                            : "/assets/img/hospital-static.jpg"
                        }
                        alt="Logo"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "10px",
                          marginTop: "5px",
                        }}
                      />
                      <h5 className="mb-0">
                        {sitedata.site_type !== "hospitals" && sitedata?.site_title ? (
                        <span>{sitedata.site_title}</span>
                      ) : (
                        sitedata?.site_title || ""
                      )}
                      </h5>
                    </Link>
                    {/* <Link to={"/"} className="logo-sticky d-flex align-items-center gap-1">
                <img
                    src={
                      sitedata?.site_logo
                        ? `${sitedata?.site_logo}`
                        : "/assets/img/hospital-static.jpg"
                    }
                    alt="Logo"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "10px",
                      marginTop: "5px",
                    }}
                  />
                  <h5 className="mb-0">
                    {sitedata.site_type !== "hospitals" &&
                    sitedata?.site_title?.length > 0 ? (
                      <span>{"Dr. " + sitedata?.site_title}</span>
                    ) : (
                      sitedata?.site_title
                    )}
                  </h5>
                </Link> */}
                  </li>
                </ul>
                <ul className="nav navbar-items pull-right">
                  <li className="list-item">
                    <ul className="nav navbar-main theme-main-menu">
                      <li className="menu-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li className="menu-item">
                        <Link to={"/about"}>About Me</Link>
                      </li>
                      
                      <li class="dropdown menu-item dropdown-sub">
                        <a>Patient Care</a>
                        <ul class="dropdown-menu">
                          <li>
                            <Link to={"/hospital-clinic/0"}>
                              Hospital/Clinic
                            </Link>
                           <Link to={"/services"}>Services</Link>
                          </li>
                        </ul>
                      </li>
                      <li class="dropdown menu-item dropdown-sub">
                        <a>Media</a>
                        <ul class="dropdown-menu">
                          <li>
                            <Link to={"/blogs"}>Blogs</Link>
                            <Link to={"/news"}>News & Update</Link>
                            {sitedata?.permissions?.review !== "hide" && (
                              <Link to={"/reviews"}>Reviews</Link>
                            )}
                            <Link to={"/gallery"}>Gallery</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="menu-item">
                        <Link to={"/contact"}>Contact Us</Link>
                      </li>
                    </ul>
                  </li>
                  <li className="list-item Login-btn-new-theme">
                    {patientLogin ? (
                      <Link to="/patient">My Account</Link>
                    ) : (
                      <Link to="/login">Login</Link>
                    )}
                  </li>

                  {/* <li className="list-item">
                <span
                  onClick={() => setSearchModal(true)}
                  className="full-view-switch text-center"
                >
                  <i className="ti-search typo-dark"></i>
                </span>
               
              </li> */}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default BoxedDoctorNavbar;
